import Vue from "vue";
import Vuex from "vuex";
import api from "@/api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fbo_data: {},
    fbo_data_error_message: "",
  },
  mutations: {
    setFBOData(state, data) {
      state.fbo_data = data;
    },
    setFBODataErrorMessage(state, message) {
      state.fbo_data_error_message = message;
    },
  },
  actions: {
    async getFBOData({ commit }, fbo_id) {
      try {
        commit("setFBODataErrorMessage", "");
        const response = await api.post("api/fbo_data/", { fbo_id });
        if (response.data.status == "success") {
          commit("setFBOData", response.data.fbo_data);
        } else if (response.data.status == "error") {
          commit("setFBODataErrorMessage", response.data.error_message);
        }
      } catch (error) {
        console.log(error);
        commit("setFBODataErrorMessage", "未能取得資料");
      }
    },
  },
  getters: {
    fboData(state) {
      return state.fbo_data;
    },
    fboDataErrorMessage(state) {
      return state.fbo_data_error_message;
    },
  },
});
